import "./pt-piping-pump-vertical.css"

export default {
  modelProperties: {
    "status": {
      type: "list",
      format: ["ON", "OFF"],
      bind: {
        to: "attr",
        name: "data-status"
      },
    }
  },
  listeners: {
        mouseenter: true,
        mouseleave: true,
    click: true,
    contextmenu: true
  }
}
